import { updateOrDelete } from '@hangar31/rc-utils';
import { useSection } from '@OnArk/contexts/section';
import { OrderableListContext } from '@OnArk/OrderedList';
import { sortByOrder } from '@OnArk/utils/arrayHelpers';

export default function SectionListWrapper({
  children,
}: React.PropsWithChildren<Record<string, any>>) {
  const { client, course, sections, setChanges, setSections } = useSection();

  return (
    <OrderableListContext
      items={sortByOrder(sections).slice(1, -1)}
      saveNewOrder={(s, initial) => {
        void client.updateCourseSectionOrder({
          data: {
            sections: updateOrDelete(s, initial, s => ({
              order: s.order,
            })),
          } as CourseUpdateInput,
          id: course.id,
        });
        setChanges(c => c + 1);
        setSections(se =>
          se.map(e => {
            const sect = s.find(i => i.id === e.id);

            if (!sect) return e;

            return { ...e, order: sect.order };
          })
        );
      }}
    >
      {children}
    </OrderableListContext>
  );
}
